import axios, { AxiosResponse } from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { FeedPostNotification, IFeed, IBranding } from '@/feed/Feed.interface'
import getApiUrl from '@/runtimeConfig'

const api = applyCaseMiddleware(
  axios.create({
    withCredentials: false,
    baseURL: getApiUrl()
  }),
  {
    preservedKeys: ['campaignGuid']
  }
)

export function getBranding({
  params,
  key,
  additionalHeaders
}: {
  params: Record<string, string | number>
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<IBranding>> {
  return api.get(
    `/api/v1/branding?${new URLSearchParams(Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)])))}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-key': key,
        ...additionalHeaders
      }
    }
  )
}

export function getFeed({
  params,
  key,
  additionalHeaders
}: {
  params: Record<string, string | number>
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<IFeed>> {
  return api.get(
    `/api/v1/notification/feed?${new URLSearchParams({ ...params, per_page: params.perPage.toString(), page: params.page.toString() })}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-key': key,
        ...additionalHeaders
      }
    }
  )
}

export function getCard({
  params,
  key,
  additionalHeaders
}: {
  params: { alias: string; guid: string }
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<FeedPostNotification>> {
  return api.get(
    `/api/v1/notification/feedpost?${new URLSearchParams({ ...params })}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-key': key,
        ...additionalHeaders
      }
    }
  )
}

export function removeNotification({
  key,
  data,
  additionalHeaders
}: {
  data: {
    guid: string
    alias: string
    campaignsGuids: string[]
  }
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<IFeed>> {
  return api.put(`/api/v1/delete_notification`, data, {
    headers: {
      'Content-Type': 'application/json',
      'x-key': key,
      ...additionalHeaders
    }
  })
}

export function saveStatistic({
  key,
  additionalHeaders,
  data
}: {
  data: Record<string, string | number>
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<IFeed>> {
  return api.post(`/api/v1/statistics`, data, {
    headers: {
      'Content-Type': 'application/json',
      'x-key': key,
      source: 'native',
      ...additionalHeaders
    }
  })
}

export function sendInAppEvent({
  key,
  additionalHeaders,
  data
}: {
  data: { alias: string; inAppEvents: { name: string; occurredAt: string }[] }
  key: string
  additionalHeaders?: Record<string, string>
}): Promise<AxiosResponse<IFeed>> {
  return api.post(`/api/v1/notification/inapp_events`, data, {
    headers: {
      'Content-Type': 'application/json',
      'x-key': key,
      ...additionalHeaders
    }
  })
}

export default api
